import React, { useState, useEffect } from 'react';
import { Card, Input, Icon, Row, Col, Form, Select, Spin } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter, Prompt } from 'dva/router';
import { ButtonBar } from '../../../components';
import styles from './../styles.less';
import config from './../../../config';
import helpers from './../../../utils/helpers';

const LeadLabelsItem = (props) => {
  const id = props.match.params.id;
  const locales = config['app.locales'];
  const [isSubmitted, setState] = useState(false);

  useEffect(() => {
    props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.LeadLabels.List.Title',
        description: 'Component.LeadLabels.List.Info',
      },
    });
    if (id) {
      props.dispatch({
        type: 'leadLabels/get',
        payload: { id },
      });
    }
  }, []);

  const handleSubmit = (e) => {
    props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        props.dispatch({
          type: `leadLabels/${id ? 'update' : 'create'}`,
          payload: {
            id,
            name: helpers.formatTranslations(values.translations, locales),
          },
        });
        setState(true);
      }
    });
    e.preventDefault();
  };

  const cancelAction = () => {
    props.dispatch({
      type: 'app/goToRoute',
      payload: { routeName: 'LEAD_LABELS_LIST' },
    });
  };

  const addTranslate = () => {
    props.dispatch({ type: 'leadLabels/addTranslate' });
  };

  const removeTranslation = (index) => {
    props.dispatch({
      type: 'leadLabels/removeTranslate',
      payload: { index },
    });
  };

  return (
    <div className={styles.containerLarge}>
      <Prompt
        when={!isSubmitted && props.form.isFieldsTouched()}
        message={props.intl.locale}
      />
      <Spin
        spinning={!!props.loading.effects['leadLabels/get']}
      >
        <Form onSubmit={handleSubmit}>
          <Card className={styles.noMarginTop}>
            <Row type="flex" gutter={32}>
              <Col span={24}>
                <Row type="flex" gutter={8}>
                  <Col span={24}>
                    <p>
                      <span className="ant-form-item-required">
                        <FormattedMessage id="Component.LeadLabels.Form.Label.Name" />:
                      </span>
                    </p>
                  </Col>
                </Row>
                {props.leadLabels.translations.map((translate, index) => (
                  <Row type="flex" gutter={8} key={`translate-${index}`}>
                    <Col span={5}>
                      <Form.Item>
                        {props.form.getFieldDecorator(`translations[${index}].locale`, {
                          initialValue: translate.locale,
                          rules: [{
                            required: true,
                            message: props.intl.formatMessage({ id: 'Common.Field.Required' }),
                          }],
                        })(
                          <Select style={{ width: '100%' }}>
                            {index === 0 ?
                              <Select.Option value={config['app.fallback_locale']}>{config['app.fallback_locale'].toUpperCase()}</Select.Option>
                              :
                              locales.map(item => (
                                item === config['app.fallback_locale'] ?
                                  null
                                  :
                                  <Select.Option value={item} key={item}>
                                    {item.toUpperCase()}
                                  </Select.Option>
                              ))}
                          </Select>,
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item>
                        {props.form.getFieldDecorator(`translations[${index}].name`, {
                          initialValue: translate.name,
                          rules: [{
                            required: true,
                            message: props.intl.formatMessage({ id: 'Common.Field.Required' }),
                          }],
                        })(
                          <Input />,
                        )}
                      </Form.Item>
                    </Col>
                    <Col span={3}>
                      {index > 0 &&
                        <div className={[styles.btnNoBorder, styles.actLink].join(' ')} onClick={() => removeTranslation(index)}>
                          <Icon type="close" />
                        </div>
                      }
                    </Col>
                  </Row>
                ))}
                {props.leadLabels.translations.length < locales.length && (
                  <div className={[styles.btnNoBorder, styles.actLink].join(' ')} onClick={addTranslate}>
                    <Icon type="plus" />
                    <FormattedMessage id="Component.Branches.Change.Form.AddTranslation" />
                  </div>
                )}
              </Col>
            </Row>
          </Card>
          <ButtonBar cancelAction={() => cancelAction()} />
        </Form>
      </Spin>
    </div>
  );
};

export default withRouter(connect(
  ({ leadLabels, loading }) => ({ leadLabels, loading }),
)(Form.create()(injectIntl(LeadLabelsItem))));



// WEBPACK FOOTER //
// ./src/components/LeadLabels/LeadLabelsItem/LeadLabelsItem.js